import { PlayIcon } from '@/icons';
import { cn } from '@/utils/tailwind.util';
type PlayCounterProps = {
  count: number;
  className?: string;
};
export const PlayCounter = ({
  count,
  className
}: PlayCounterProps) => {
  return <div className={cn('flex items-center gap-2xs text-neutral', className)} data-sentry-component="PlayCounter" data-sentry-source-file="PlayCounter.tsx">
      <PlayIcon size="xs" className="hidden tablet-sm:block" data-sentry-element="PlayIcon" data-sentry-source-file="PlayCounter.tsx" />
      <PlayIcon size="2xs" className="tablet-sm:hidden" data-sentry-element="PlayIcon" data-sentry-source-file="PlayCounter.tsx" />
      <span>{count.toLocaleString()}</span>
    </div>;
};